import React, { useEffect, useState } from 'react';
import { Phone, Mail, MapPin, Clock, Send } from 'lucide-react';
import { CTABanner } from '../components/CTABanner';
export function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    serviceType: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success'>('idle');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({
        name: '',
        phone: '',
        email: '',
        serviceType: '',
        message: ''
      });
      // Reset success message after 5 seconds
      setTimeout(() => setSubmitStatus('idle'), 5000);
    }, 1500);
  };
  return <div className="w-full" data-id="element-306">
      {/* Hero */}
      <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden bg-navy" data-id="element-307">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1423666639041-f56000c27a9a?w=1200')] bg-cover bg-center opacity-20" data-id="element-308"></div>
        <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-309">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-montserrat font-black text-white mb-6" data-id="element-310">
            Get a Free Quote
          </h1>
          <p className="text-xl text-cream max-w-3xl mx-auto" data-id="element-311">
            Ready to restore your property's beauty? Contact us today for a
            fast, free, no-obligation estimate.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-312">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-313">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-314">
            {/* Contact Form */}
            <div className="bg-white p-8 md:p-10 rounded-2xl shadow-xl border border-gray-100" data-id="element-315">
              <h2 className="text-3xl font-montserrat font-bold text-navy mb-6" data-id="element-316">
                Send Us a Message
              </h2>

              {submitStatus === 'success' && <div className="mb-6 p-4 bg-green-50 text-green-700 rounded-lg border border-green-200 flex items-center" data-id="element-317">
                  <div className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-318"></div>
                  Thank you! Your message has been sent. We'll be in touch
                  shortly.
                </div>}

              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-319">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-320">
                  <div data-id="element-321">
                    <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-322">
                      Full Name *
                    </label>
                    <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-light-blue focus:border-light-blue transition-colors outline-none" placeholder="John Doe" data-id="element-323" />
                  </div>
                  <div data-id="element-324">
                    <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-325">
                      Phone Number *
                    </label>
                    <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-light-blue focus:border-light-blue transition-colors outline-none" placeholder="586-298-2727" data-id="element-326" />
                  </div>
                </div>

                <div data-id="element-327">
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-328">
                    Email Address *
                  </label>
                  <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-light-blue focus:border-light-blue transition-colors outline-none" placeholder="john@example.com" data-id="element-329" />
                </div>

                <div data-id="element-330">
                  <label htmlFor="serviceType" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-331">
                    Service Needed
                  </label>
                  <select id="serviceType" name="serviceType" value={formData.serviceType} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-light-blue focus:border-light-blue transition-colors outline-none bg-white" data-id="element-332">
                    <option value="" data-id="element-333">Select a service...</option>
                    <option value="Residential" data-id="element-334">
                      Residential Soft Washing
                    </option>
                    <option value="Roof" data-id="element-335">Roof Cleaning</option>
                    <option value="Gutter" data-id="element-336">Gutter Cleaning</option>
                    <option value="Driveway" data-id="element-337">Driveway & Concrete</option>
                    <option value="Deck" data-id="element-338">Deck & Patio</option>
                    <option value="Fence" data-id="element-339">Fence Cleaning</option>
                    <option value="Commercial" data-id="element-340">Commercial Services</option>
                    <option value="Other" data-id="element-341">Other / Multiple</option>
                  </select>
                </div>

                <div data-id="element-342">
                  <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-343">
                    How can we help? *
                  </label>
                  <textarea id="message" name="message" required rows={4} value={formData.message} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-light-blue focus:border-light-blue transition-colors outline-none resize-none" placeholder="Tell us about your property and what needs cleaning..." data-id="element-344"></textarea>
                </div>

                <button type="submit" disabled={isSubmitting} className="w-full bg-navy text-white font-bold py-4 px-8 rounded-lg hover:bg-light-blue transition-colors flex items-center justify-center disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-345">
                  {isSubmitting ? <span className="flex items-center" data-id="element-346">
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-347">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-348"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-349"></path>
                      </svg>
                      Sending...
                    </span> : <span className="flex items-center" data-id="element-350">
                      <Send className="w-5 h-5 mr-2" data-id="element-351" />
                      Get My Free Quote
                    </span>}
                </button>
              </form>
            </div>

            {/* Contact Info */}
            <div className="space-y-8" data-id="element-352">
              <div className="bg-navy text-white p-8 rounded-2xl shadow-xl relative overflow-hidden" data-id="element-353">
                <div className="absolute top-0 right-0 -mr-10 -mt-10 w-40 h-40 bg-light-blue opacity-20 rounded-full blur-2xl" data-id="element-354"></div>
                <h3 className="text-2xl font-montserrat font-bold mb-8 relative z-10" data-id="element-355">
                  Contact Information
                </h3>

                <div className="space-y-6 relative z-10" data-id="element-356">
                  <div className="flex items-start" data-id="element-357">
                    <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center shrink-0 mr-4" data-id="element-358">
                      <Phone className="w-6 h-6 text-light-blue" data-id="element-359" />
                    </div>
                    <div data-id="element-360">
                      <p className="text-sm text-cream mb-1" data-id="element-361">Call or Text Us</p>
                      <a href="tel:586-298-2727" className="text-xl font-bold hover:text-light-blue transition-colors" data-id="element-362">
                        586-298-2727
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start" data-id="element-363">
                    <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center shrink-0 mr-4" data-id="element-364">
                      <Mail className="w-6 h-6 text-light-blue" data-id="element-365" />
                    </div>
                    <div data-id="element-366">
                      <p className="text-sm text-cream mb-1" data-id="element-367">Email Us</p>
                      <a href="mailto:SoftwashPros@gmail.com" className="text-lg font-bold hover:text-light-blue transition-colors break-all" data-id="element-368">
                        SoftwashPros@gmail.com
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start" data-id="element-369">
                    <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center shrink-0 mr-4" data-id="element-370">
                      <Clock className="w-6 h-6 text-light-blue" data-id="element-371" />
                    </div>
                    <div data-id="element-372">
                      <p className="text-sm text-cream mb-1" data-id="element-373">Business Hours</p>
                      <p className="font-bold" data-id="element-374">Mon - Sat: 7:00 AM - 7:00 PM</p>
                      <p className="text-cream text-sm" data-id="element-375">
                        Sunday: By Appointment
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="bg-gray-200 rounded-2xl h-64 flex flex-col items-center justify-center text-gray-500 shadow-inner border border-gray-300" data-id="element-376">
                <MapPin className="w-12 h-12 mb-3 text-gray-400" data-id="element-377" />
                <p className="font-montserrat font-bold text-lg" data-id="element-378">
                  Serving the Greater Metro Area
                </p>
                <p className="text-sm mt-1" data-id="element-379">Map integration placeholder</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}